/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function e(e) {
  const i = () => e("visible" === document.visibilityState);
  return document.addEventListener("visibilitychange", i), {
    remove: () => document.addEventListener("visibilitychange", i)
  };
}
export { e as onVisibilityChange };